// extracted by mini-css-extract-plugin
export var label = "_g2-2";
export var slideContainer = "_g2-0";
export var slider = "_g2-1";